var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{class:_vm.iconClass}),_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.showGroupName)?_c('span',{staticClass:"smaller"},[_vm._v(_vm._s(_vm.groupName)+" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.groupIdentifier)+" ")])]):_vm._e()])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }